import React from "react";
import {Box} from '@mui/material';
const BottomImage = () => {

    return (
        <Box
            component="img"
            src={`${process.env.PUBLIC_URL}/images/meon_loginPage.png`}
            alt="Bottom Image"
            sx={{
                width: "100%",
                height: "auto",
                position: "absolute",
                bottom: 0,
                left: 0
            }}
        />
    )
}
export default BottomImage;